import { createSlice } from '@reduxjs/toolkit'
import {
  getLandingUrlDto,
  getLandingUrlState,
} from 'features/creative/creativeUtil'
import { validateLandingUrlWithSiteUrl } from 'features/creative/add/common/useCreativeValidation'

export const subjectTypes = [
  { id: 'DISCOUNT', name: '할인' },
  { id: 'EVENT', name: '이벤트' },
  { id: 'AUTH', name: '인증' },
  { id: 'RELATION', name: '연관기사' },
]

const initialState = {
  selectedSubject: null,
  description: '',
  landingUrl: {
    individual: false,
    mobileUrl: '',
    pcUrl: '',
  },
}

export const validateSubject = (active, state, siteUrl) => ({
  subject: active && !state.selectedSubject && '말머리를 선택하세요.',
  description: active && state.description === '' && '내용을 입력하세요.',
  ...(active && validateLandingUrlWithSiteUrl(state.landingUrl, siteUrl)),
})

export const getSubjectAssetData = state => ({
  type: 'SUBJECT',
  data: {
    kind: state.selectedSubject.id,
    text: state.description,
    landingUrl: getLandingUrlDto(state.landingUrl),
  },
})

const subjectSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {
    reset: () => initialState,
    selectSubject: (state, { payload: subject }) => {
      state.selectedSubject = subject
    },
    setDescription: (state, { payload: description }) => {
      state.description = description
    },
    setIndividual: (state, { payload: checked }) => {
      state.landingUrl.individual = checked
    },
    setMobileUrl: (state, { payload: url }) => {
      state.landingUrl.mobileUrl = url
    },
    setPcUrl: (state, { payload: url }) => {
      state.landingUrl.pcUrl = url
    },
    setSubject: (state, { payload: { kind, text, landingUrl } }) => {
      state.selectedSubject = subjectTypes.find(type => type.id === kind)
      state.description = text
      state.landingUrl = getLandingUrlState(landingUrl)
    },
  },
})

export const {
  reset,
  setDescription,
  setPcUrl,
  setMobileUrl,
  setIndividual,
  selectSubject,
  setSubject,
} = subjectSlice.actions

export default subjectSlice.reducer
